export default {
    data() {
        return {
            sliderOptions: {
                slidesPerView: 1,
                spaceBetween: 60,
                speed: 600,
                cursor: "grab",
                navigation: {
                    nextEl: '.js-slider-next',
                    prevEl: '.js-slider-prev',
                }
            },
        }
    },
    methods: {

    }
};



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/service-slider/component.js